<app-navbar-white></app-navbar-white>
<div class="section-conatiner container-fluid">
<div class="text-heading d-web"><span>Thank you</span> for contacting us</div>
<div class="text-heading d-mobile"><span>Thank you</span> <br>for contacting us</div>
<div class="small-heading">We'll get back to you very soon.</div>
<div class="text-para">In the meantime, check out our resources to get fantastic tips on handling your money.</div>
<div class="btn-container"><button type="button" [routerLink]="['/resources']" class="btn btn-submit" >DISCOVER OUR TIPS</button></div>
<div class="go-home"  [routerLink]="['/home']">GO BACK TO HOMEPAGE</div>
</div>    
<app-footer-new></app-footer-new>